export const SIDEBAR_SHOW = 'SIDEBAR_SHOW'
export const NEW_TOAST = 'NEW_TOAST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const CUSTOMERS = 'CUSTOMERS'
export const ADMINS = 'ADMINS'
export const PAYMENT_HISTORY = 'PAYMENT_HISTORY'
export const SWAL_PROPS = 'SWAL_PROPS'
export const IS_LOADING = 'IS_LOADING'
